import { Ucum } from '@treetop/shared/model';

import { ucumToDateFromDate } from './ucum.util';

/**
 * This function checks if the given date is in the past.
 * @param date Date to check
 */
export const isDateInPast = (date: Date): boolean => {
  if (!date) {
    return false;
  }

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  const currentDate = new Date();
  return currentDate.getTime() > date.getTime();
};

/**
 * This function checks if the given date is within the given UCUM.
 * @param date Date to check
 * @param ucum UCUM to check
 * @param fromDate Current date, default is the current date
 */
export const isDateWithinUCUM = (date: Date, ucum: Ucum, fromDate = new Date()): boolean => {
  if (!date || !ucum) {
    return false;
  }

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  const savedDate = new Date(date);
  const savedFromDate = new Date(fromDate);

  const dueDate = ucumToDateFromDate(ucum, savedFromDate);
  return savedDate.getTime() <= dueDate.getTime();
};
